import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";
import { memo } from "react";

interface DefaultStoreProjectAssigneesDeleteSelectedButtonProps {
  onClick: () => void;
}

const DefaultStoreProjectAssigneesDeleteSelectedButtonComponent = ({
  onClick,
}: DefaultStoreProjectAssigneesDeleteSelectedButtonProps) => {
  const { t } = useTranslation();
  const { can_delete } = useModulePermissions();
  const selectedCount = useRowSelectionCount();

  return (
    <Button
      disabled={selectedCount === 0 || !can_delete}
      variant="secondary"
      size="sm"
      onClick={onClick}
    >
      <Trash2 className="w-4 h-4 mr-2" />
      {t("defaultStoreProjectAssignees.buttons.deleteSelected")}
    </Button>
  );
};

export const DefaultStoreProjectAssigneesDeleteSelectedButton = memo(
  DefaultStoreProjectAssigneesDeleteSelectedButtonComponent,
);
